// src/components/pages/Produto/tabs/MateriaPrimaTabPanel.jsx
import React, { useMemo } from 'react';

import formStyles from '../../../form/Form.module.css';

import DataList from '../../../form/DataList';
import InputNumber from '../../../form/InputNumber';
import Checkbox from '../../../form/Checkbox';

import { ThemeProvider } from '@mui/material/styles';
import { Box, Tooltip, IconButton, Button } from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';

import { MaterialReactTable } from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

const MateriaPrimaTabPanel = ({ module, theme, mrt, isError, isLoading, isRefetching }) => {
    const { parametro, materiaPrima, OptionsMateriaPrima, novaMateriaPrima, produtoComposicoes, rowCountComposicoes } =
        module.state;

    const { change, limparMateriaPrima, saveMateriaPrima, selectMateriaPrimaRow } = module.actions;

    const {
        columnFilterFns,
        setColumnFiltersMode,
        columnFilters,
        setColumnFilters,
        globalFilter,
        setGlobalFilter,
        sorting,
        setSorting,
        pagination,
        setPagination,
    } = mrt;

    const columns = useMemo(
        () => [
            {
                accessorKey: 'materiaPrima.descricao',
                header: 'Matéria Prima',
                muiTableBodyCellProps: ({ row, cell }) => ({
                    onClick: () => {
                        console.info(row.original);
                    },
                }),
            },
            {
                accessorKey: 'percentual',
                header: 'Percentual (%)',
            },
            {
                accessorKey: 'ingrediente',
                header: 'Ingrediente',
                Cell: ({ row }) => (row.original.ingrediente ? 'Sim' : 'Não'),
            },
            {
                accessorKey: 'recheio',
                header: 'Recheio',
                Cell: ({ row }) => (row.original.recheio ? 'Sim' : 'Não'),
            },
            {
                accessorKey: 'alteraEstoque',
                header: 'Altera Estoque',
                Cell: ({ row }) => (row.original.alteraEstoque ? 'Sim' : 'Não'),
            },
            {
                accessorKey: 'calculaUnidade',
                header: 'Unidade',
                Cell: ({ row }) => (row.original.calculaUnidade ? 'Sim' : 'Não'),
            },
            {
                accessorKey: 'ativo',
                header: 'Ativo',
                Cell: ({ row }) => (row.original.ativo ? 'Sim' : 'Não'),
            },
        ],
        []
    );

    return (
        <div className={formStyles.stiloPadrao}>
            <h4>Informações da composição do produto</h4>

            {/* ======================= */}
            {/* FORM SUPERIOR           */}
            {/* ======================= */}
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                }}
            >
                <DataList
                    text="Matéria Prima"
                    title="Compõe o produto"
                    placeholder="matéria prima do produto"
                    name="novaMateriaPrima.materiaPrima.descricao"
                    inputWidth="400px"
                    filteredOptions={OptionsMateriaPrima}
                    handleOnChange={change}
                    value={materiaPrima?.descricao || ''}
                />

                <InputNumber
                    text="Percentual"
                    name="novaMateriaPrima.percentual"
                    placeholder="perc %"
                    inputWidth="80px"
                    handleOnChange={change}
                    value={novaMateriaPrima?.percentual || ''}
                    textAlign="center"
                />

                {parametro?.Empresa?.ramoAtividade === 'Padaria' && (
                    <>
                        <Checkbox
                            text="Ingrediente"
                            name="novaMateriaPrima.ingrediente"
                            handleOnChange={change}
                            value={novaMateriaPrima?.ingrediente}
                            checked={!!novaMateriaPrima?.ingrediente}
                        />
                        <Checkbox
                            text="Recheio"
                            name="novaMateriaPrima.recheio"
                            handleOnChange={change}
                            value={novaMateriaPrima?.recheio}
                            checked={!!novaMateriaPrima?.recheio}
                        />
                        <Checkbox
                            text="Altera Estoque"
                            name="novaMateriaPrima.alteraEstoque"
                            handleOnChange={change}
                            value={!novaMateriaPrima?.alteraEstoque}
                            checked={novaMateriaPrima?.alteraEstoque}
                        />
                        <Checkbox
                            text="Unidade"
                            name="novaMateriaPrima.calculaUnidade"
                            handleOnChange={change}
                            value={novaMateriaPrima?.calculaUnidade}
                            checked={!!novaMateriaPrima?.calculaUnidade}
                        />
                    </>
                )}

                <Checkbox
                    text="Ativo"
                    name="novaMateriaPrima.ativo"
                    handleOnChange={change}
                    value={novaMateriaPrima?.ativo}
                    checked={!!novaMateriaPrima?.ativo}
                />

                <Button variant="contained" color="inherit" onClick={limparMateriaPrima} style={{ marginLeft: '10px' }}>
                    Limpar
                </Button>

                <Button
                    variant="contained"
                    color={String(novaMateriaPrima?.funcao || '').toLowerCase() === 'deletar' ? 'error' : 'info'}
                    onClick={saveMateriaPrima}
                    disabled={!materiaPrima?.descricao || !novaMateriaPrima?.percentual}
                    style={{ marginLeft: '5px' }}
                >
                    {novaMateriaPrima?.funcao}
                </Button>
            </div>

            {/* ======================= */}
            {/* GRID                    */}
            {/* ======================= */}
            <ThemeProvider theme={theme}>
                <MaterialReactTable
                    columns={columns}
                    data={produtoComposicoes}
                    rowCount={rowCountComposicoes}
                    getRowId={(row) => row.uuid || row.id}
                    manualFiltering
                    manualPagination
                    manualSorting
                    enableColumnFilterModes
                    enableGlobalFilterModes
                    enableColumnOrdering
                    enableEditing
                    enableRowSelection
                    renderRowActions={({ row }) => (
                        <Box sx={{ display: 'flex', gap: '1rem' }}>
                            <Tooltip arrow placement="top" title="Editar">
                                <span>
                                    <IconButton onClick={() => selectMateriaPrimaRow(row.original, row.index, 'Editar')}>
                                        <Edit />
                                    </IconButton>
                                </span>
                            </Tooltip>

                            <Tooltip arrow placement="right" title="Deletar">
                                <span>
                                    <IconButton
                                        color="error"
                                        onClick={() => selectMateriaPrimaRow(row.original, row.index, 'Deletar')}
                                    >
                                        <Delete />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </Box>
                    )}
                    muiToolbarAlertBannerProps={
                        isError
                            ? {
                                  color: 'error',
                                  children: 'Erro ao carregar dados',
                              }
                            : undefined
                    }
                    onColumnFiltersChange={setColumnFilters}
                    onColumnFilterFnsChange={setColumnFiltersMode}
                    onGlobalFilterChange={setGlobalFilter}
                    onPaginationChange={setPagination}
                    onSortingChange={setSorting}
                    state={{
                        columnFilterFns,
                        columnFilters,
                        globalFilter,
                        isLoading,
                        pagination,
                        showAlertBanner: isError,
                        showProgressBars: isRefetching,
                        sorting,
                    }}
                    initialState={{
                        showColumnFilters: true,
                        density: 'compact',
                    }}
                    positionExpandColumn="first"
                    positionActionsColumn="first"
                    positionToolbarAlertBanner="bottom"
                    localization={MRT_Localization_PT_BR}
                />
            </ThemeProvider>
        </div>
    );
};
export default React.memo(MateriaPrimaTabPanel);
